import React, {useContext, useState} from 'react';
import {AppCtx} from './partnerWeb/configs/appContext';
import {
  getLocalData,
  LocalStorageType,
} from './partnerWeb/configs/localStorage';
import {getUserContext, navigationRef} from './partnerWeb/configs/util';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {
  getPathFromState,
  NavigationContainer,
  PathConfigMap,
} from '@react-navigation/native';
import _ from 'lodash';
import {ROUTE_PLATFORM} from './platformDasboard/utils/types';
import PlatformDashboardLogin from './platformDasboard/platformDashboardLogin';
import PlatformDashboardMF from './platformDasboard/platformDashboardMF';
import ThemeProvider, {THEMES} from '@voltmoney/theme';
import {ROUTE_PARTNER} from './partnerWeb/configs/types';

const Stack = createNativeStackNavigator();

const PlatformDashboard: React.FunctionComponent = () => {
  const AppContext = useContext(AppCtx);
  ThemeProvider.init(THEMES.LIGHT_MOBILE);

  const config: {
    initialRouteName?: string | number | undefined;
    screens: PathConfigMap<any>;
  } = {
    screens: {
      initialRouteName: ROUTE_PLATFORM.SIGNUP,
      path: `${ROUTE_PLATFORM.PLATFORM}`,
      [ROUTE_PLATFORM.SIGNUP]: {
        path: `${ROUTE_PLATFORM.PLATFORM}/${ROUTE_PLATFORM.SIGNUP}/:params?`,
        exact: true,
      },
      [ROUTE_PLATFORM.DASHBOARD]: {
        path: `${ROUTE_PLATFORM.PLATFORM}/${ROUTE_PLATFORM.DASHBOARD}/:params?`,
        exact: true,
      },
      [ROUTE_PLATFORM.LEADS]: {
        path: `${ROUTE_PLATFORM.PLATFORM}/${ROUTE_PLATFORM.LEADS}/:params?`,
        exact: true,
      },
      [ROUTE_PLATFORM.ACTIVE_CUSTOMER]: {
        path: `${ROUTE_PLATFORM.PLATFORM}/${ROUTE_PLATFORM.ACTIVE_CUSTOMER}/:params?`,
        exact: true,
      },
      [ROUTE_PLATFORM.LINKED_PARTNER]: {
        path: `${ROUTE_PLATFORM.PLATFORM}/${ROUTE_PLATFORM.LINKED_PARTNER}/:params?`,
        exact: true,
      },
    },
  };

  return (
    <AppCtx.Provider value={AppContext}>
      <NavigationContainer
        ref={navigationRef}
        documentTitle={{
          enabled: false,
        }}
        linking={{
          prefixes: [
            'https://app.voltmoney.in',
            'https://app.staging.voltmoney.in',
            'voltmoney://',
            'http://localhost:3000',
            'localhost:3000',
          ],
          config,
          getPathFromState: (state, options) => {
            /*** Manually extracted params adding back in URL ***/
            return `${getPathFromState(state, options)}${
              window.location.href.includes('?')
                ? `?${window.location.href.split('?')[1]}`
                : ''
            }`;
          },
        }}>
        <Stack.Navigator initialRouteName={ROUTE_PLATFORM.SIGNUP}>
          <Stack.Screen
            name={ROUTE_PLATFORM.SIGNUP}
            component={PlatformDashboardLogin}
            options={{
              title: 'Volt Partners | Login or Empanel',
              props: {route: ROUTE_PLATFORM.SIGNUP},
            }}
          />
          <Stack.Screen
            name={ROUTE_PLATFORM.DASHBOARD}
            component={PlatformDashboardMF}
            options={{
              title: 'Volt Partners | Dashboard',
              props: {route: ROUTE_PLATFORM.DASHBOARD},
            }}
          />
          <Stack.Screen
            name={ROUTE_PLATFORM.LEADS}
            component={PlatformDashboardMF}
            options={{
              title: 'Volt Partners | Dashboard',
              props: {route: ROUTE_PLATFORM.LEADS},
            }}
          />
          <Stack.Screen
            name={ROUTE_PLATFORM.ACTIVE_CUSTOMER}
            component={PlatformDashboardMF}
            options={{
              title: 'Volt Partners | Dashboard',
              props: {route: ROUTE_PLATFORM.ACTIVE_CUSTOMER},
            }}
          />
          <Stack.Screen
            name={ROUTE_PLATFORM.LINKED_PARTNER}
            component={PlatformDashboardMF}
            options={{
              title: 'Volt Partners | Dashboard',
              props: {route: ROUTE_PLATFORM.LINKED_PARTNER},
            }}
          />
        </Stack.Navigator>
      </NavigationContainer>
    </AppCtx.Provider>
  );
};
export default PlatformDashboard;
